<template>
  <collapse-default :id="'testemunha'"
                    :collapse-visible="collapseVisible"
                    :condition="testemunhas.length">
    <template v-slot:header>
      Testemunhas {{ !testemunhas.length ? ' - Nenhum informado' : '' }}
    </template>

    <template v-slot:content>
      <div v-for="(testemunha, index) in testemunhas"
           :key="`${index}-testemunha`"
           class="mt-3">
        <div class="resumo-show_header--blue">
          {{ testemunha.pessoa.nome || 'Não informado' }}
        </div>
        <div class="pl-3 pb-1 row">
          <div class="col">
            <div class="row">
              <div class="col">
                <label class="resumo-show_header--label">CPF</label>
                <div
                  class="resumo-show_header--sublabel">
                  {{ testemunha.pessoa.cpf || 'Não informado' }}
                </div>
              </div>
              <div class="col">
                <label class="resumo-show_header--label">Profissão</label>
                <div
                  class="resumo-show_header--sublabel">
                  {{ testemunha.pessoa.ocupacao_declarada || 'Não informado' }}
                </div>
              </div>
              <div class="col">
                <label class="resumo-show_header--label">Nacionalidade</label>
                <div
                  class="resumo-show_header--sublabel">
                  {{ testemunha.pessoa.nacionalidade ? testemunha.pessoa.nacionalidade.nome : 'Não informado' }}
                </div>
              </div>
              <div class="col">
                <label class="resumo-show_header--label">Estado Civil</label>
                <div class="resumo-show_header--sublabel">
                  {{ testemunha.pessoa.estado_civil || 'Não informado' }}
                </div>
              </div>
              <div class="col">
                <label class="resumo-show_header--label">RG</label>
                <div class="resumo-show_header--sublabel">
                  {{ documentoRG(testemunha.pessoa.documentos) ||'Não informado' }}
                </div>
              </div>
              <div class="col">
                <label class="resumo-show_header--label">Endereço Cadastrado</label>
                <div class="resumo-show_header--sublabel">
                  {{ (testemunha.pessoa.endereco) ? 'Sim' : 'Não' }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </collapse-default>
</template>

<script>
  import CollapseDefault from "./CollapseDefault"


  export default {
    name: "RegistrosAnteriores",
    components: {
      CollapseDefault,
    },
    props: {
      testemunhas: {
        type: Array,
        default: () => ([])
      },
      collapseVisible: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      documentoRG (documentos) {
        const rg = documentos.find(doc => doc.tipo_documento === "RG")

        return rg ? rg.numero : null
      }
    },
  }
</script>

<style scoped>

</style>
